module.exports = __webpack_public_path__ + "img/pr4.398f003f.jpg";